<p libAndromedaTooltip="{{ this.tooltipEntity }}">
  {{ this.entity }}
</p>
